import React from "react";

import { Permission } from "~/models/dto";

import type { MonitorCheckStatusConfiguredSilencingRule } from "../../../../../../common/openapi";
import { usePermissions } from "../../../../../../common/use-permissions";

import { ActiveRulesAlert } from "./common/active-rules-alert";
import { AppliesTo } from "./common/applies-to";
import { CannotRemoveRuleAlert } from "./common/cannot-remove-rule-alert";
import { InternalLiveRuleTiming } from "./common/internal-live-rule-timing";
import { RemoveRuleAction } from "./common/remove-rule-action";
import { RuleSelector } from "./common/rule-selector";
import { SilencingNote } from "./common/silencing-note";

export function InternalLiveWithSelector({ rule }: { rule: MonitorCheckStatusConfiguredSilencingRule }) {
	const permissions = usePermissions();
	const hasUnmutePermissions = permissions?.hasSystemPermission(Permission.DeleteSilencingRules) ?? false;

	return (
		<div className="drawer-body flex flex-col gap-6">
			<ActiveRulesAlert />
			<RuleSelector />
			{!hasUnmutePermissions && <CannotRemoveRuleAlert />}
			<InternalLiveRuleTiming rule={rule} />
			<SilencingNote note={rule.note} />
			<AppliesTo />
			{hasUnmutePermissions && <RemoveRuleAction rule={rule} />}
		</div>
	);
}
